import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { spacing } from '@mobi/component-library/Theme/Common'
import { HeaderPillStyled } from './BetSelectionInfo/Components/BetInfoHeader/Components/Common/Header.styles'

export const HeaderStyled = styled.header({
  padding: `1rem ${spacing.sm}`,
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  fontSize: '1.2rem',
})

export const QuickbetBodyStyled = styled.div({
  padding: `1.5rem ${spacing.sm} 0rem ${spacing.sm}`,
  background: hexColors.whiteSmoke,
  minHeight: '13rem',
  overflow: 'auto',
})

export const QuickbetActionsStyled = styled.footer({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100%',
  padding: spacing.sm,
})

export const TitleStyled = styled.div({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
  width: 'calc(100% - 2.5rem)',
  fontSize: '1.4rem',
  fontWeight: 'bold',
  lineHeight: 1.3,
})

export const CountdownPillStyled = styled(HeaderPillStyled)({
  display: 'flex',
  alignItems: 'center',
  minHeight: '2rem',
  fontWeight: 'bold',
  marginLeft: '0.7rem',
  maxWidth: '100%',
})
